
import React from "react";
import { Schemes } from "../../../../utils";
import { i18nManager } from "../../../../i18n";
import { Elements } from "../../../shared/Elements";
import { Button, Checkbox, Form } from "@rivtn/noseur";
import { BaseService, ConsusService, HostService, IHost, IHostWebsite, IMember, SanitizedResponse } from "../../../../services";
import { Siren } from "../../../shared/ConfirmDialog";

export interface TournamentsProps {
    host: IHost;
    profile: IMember;
    hostWebsite: IHostWebsite;
}

function Tournaments(props: TournamentsProps) {

    const { host } = props;
    const hostService = HostService.getInstance();
    const labels = i18nManager.Labels.host.settings.tournaments;
    const [hostWebsite, setHostWebsite] = React.useState<IHostWebsite>(props.hostWebsite);
    const maxSponsors = 5; // TODO FETCH FROM PLAN

    return (<Form scheme={Schemes.OMNEHOST} className="profile-settings team-settings">
        <Checkbox label={labels.enable_ads} defaultChecked={hostWebsite?.tournaments_page_settings?.enable_rivtn_ad} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, enable_rivtn_ad: checked } });
        }} />
        <hr />
        <Checkbox label={labels.show_cancel_tours} defaultChecked={hostWebsite?.tournaments_page_settings?.show_cancelled_tournament} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, show_cancelled_tournament: checked } });
        }} />
        <Checkbox label={labels.show_ended_tours} defaultChecked={hostWebsite?.tournaments_page_settings?.show_ended_tournament} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, show_ended_tournament: checked } });
        }} />
        <Checkbox label={labels.show_ongoing_tours} defaultChecked={hostWebsite?.tournaments_page_settings?.show_ongoing_tournament} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, show_ongoing_tournament: checked } });
        }} />
        <Checkbox label={labels.show_future_tours} defaultChecked={hostWebsite?.tournaments_page_settings?.show_future_tournament} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, show_future_tournament: checked } });
        }} />
        <Checkbox label={labels.show_closed_tours} defaultChecked={hostWebsite?.tournaments_page_settings?.show_closed_tournament} onChecked={(checked) => {
            setHostWebsite({ ...hostWebsite, tournaments_page_settings: { ...hostWebsite.tournaments_page_settings, show_closed_tournament: checked } });
        }} />
        <Button scheme={Schemes.OMNEHOST} text={i18nManager.Labels.common.save_changes} loadingProps={Elements.BUTTON_LOADING_PROPS}
            style={{ marginTop: 20 }} onClick={(e) => {
                e.manageRef?.setLoadingState(true);
                updateHostWebsite(() => e.manageRef?.setLoadingState(false));
            }} />
    </Form>);

    function updateHostWebsite(onDone?: () => void) {
        hostService.updateHostWebsite(host.external_id, hostWebsite!).then(({ sanitized }: SanitizedResponse<IHostWebsite>) => {
            setHostWebsite(sanitized);
            Siren.alert(labels.update_successful);
        }).catch(BaseService.reportError).finally(onDone);
    }

}

export default Tournaments;
